import { render, staticRenderFns } from "./ChainHistoryView.vue?vue&type=template&id=7b172aed"
import script from "./ChainHistoryView.vue?vue&type=script&lang=js"
export * from "./ChainHistoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports